import { AiDao } from './AiDao';
import { CollaborationDao } from './CollaborationDao';
import { CustomModuleDao } from './CustomModuleDao';
import { devSession } from './devSession';
import { GlobalDefinitionsDao } from './GlobalDefinitionsDao';
import { HttpClient } from './HttpClient';
import { MeDao } from './MeDao';
import { MetadataDao } from './MetadataDao';
import { OverrideDao } from './OverrideDao';
import { PlatformDao } from './PlatformDao';
import { RecordsDao } from './RecordsDao';
import { SearchDao } from './SearchDao';
import { WorkspaceDao } from './WorkspaceDao';

export const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api/v1';

/** Заголовки запиту: мова та (у Development) Dev-користувач. У продуктиві — Bearer від BFF (cookie). */
function headers(): Record<string, string> {
  const h: Record<string, string> = { 'Accept-Language': devSession.lang };
  const devUser = devSession.user;
  if (devUser) h['X-Dev-User'] = devUser;
  return h;
}

const http = new HttpClient({ baseUrl: API_BASE, headers });

/** Єдина точка доступу до транспортного шару. RTK Query (state/api) викликає лише ці методи. */
export const dao = {
  records: new RecordsDao(http),
  collaboration: new CollaborationDao(http),
  metadata: new MetadataDao(http),
  workspaces: new WorkspaceDao(http),
  me: new MeDao(http),
  search: new SearchDao(http),
  ai: new AiDao(http),
  platform: new PlatformDao(http),
  overrides: new OverrideDao(http),
  globals: new GlobalDefinitionsDao(http),
  customModules: new CustomModuleDao(http),
};
